import { usStateByName, usStateCodes } from 'hero-utils/address/states';
import { string } from 'yup';
const stateValidator = string().test('isState', 'Not valid US state', (value) => {
    if (!value) {
        return false;
    }
    if (usStateCodes.includes(value.toUpperCase())) {
        return true;
    }
    if (usStateByName(value)) {
        return true;
    }
    return false;
});
export default stateValidator;
//# sourceMappingURL=index.js.map